/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Highest risk level among all files in this detection
 * @export
 */
export const ControlFileRisk = {
    Benign: 'BENIGN',
    Malware: 'MALWARE',
    LateStage: 'LATE_STAGE',
    Nuisance: 'NUISANCE',
    LiveOffTheLand: 'LIVE_OFF_THE_LAND',
    RemoteManagement: 'REMOTE_MANAGEMENT',
    Unknown: 'UNKNOWN'
} as const;
export type ControlFileRisk = typeof ControlFileRisk[keyof typeof ControlFileRisk];


export function ControlFileRiskFromJSON(json: any): ControlFileRisk {
    return ControlFileRiskFromJSONTyped(json, false);
}

export function ControlFileRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFileRisk {
    return json as ControlFileRisk;
}

export function ControlFileRiskToJSON(value?: ControlFileRisk | null): any {
    return value as any;
}

